"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = exports.grabber = exports.card = void 0;

var _util = require("../../../util");

const card = ({
  cssProps,
  theme
}) => {
  const {
    alignment,
    open,
    minWidth,
    zIndex = 1
  } = cssProps;
  return {
    left: alignment === 'left' ? 0 : undefined,
    marginLeft: alignment === 'center' ? '-50%' : undefined,
    maxHeight: 400,
    minWidth,
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'absolute',
    right: alignment === 'right' ? 0 : undefined,
    top: "calc(100% + ".concat((0, _util.spacing)(theme, 'xsmall'), "px)"),
    transition: 'opacity 0.2s ease, transform 0.2s ease !important',
    transformOrigin: 'top center 10px',
    zIndex,
    ...(open ? {
      opacity: 1,
      transform: 'none'
    } : {
      opacity: 0,
      pointerEvents: 'none',
      transform: 'scaleY(0.75) translateY(-25%)'
    })
  };
};

exports.card = card;

const grabber = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'interactive.inverse.active'),
  borderRadius: 8,
  height: 4,
  width: 32
});

exports.grabber = grabber;

const root = () => ({
  position: 'relative'
});

exports.root = root;
//# sourceMappingURL=DropDown.style.js.map